import styled from "styled-components";
import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
import { HXPageTitleText, Subtitle } from "./HXDesktopPage.styles";
import { FlexColumn } from "./common.styles";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { HXPage } from "./HXDesktopPage";
export const PatientsParent = styled(HXPage) `
    display: flex;
    flex-direction: column;
    height: 100%;
`;
export const PatientsContentContainer = styled(FlexColumn) `
    flex: 1 0 0;
`;
export const PatientsTitle = styled(HXPageTitleText) `
    padding: 24px 0;
`;
export const PatientsSearchContainer = styled(FlexColumn) `
    padding: 24px;
    gap: 16px;

    border-radius: 4px;
    border: 1px solid ${colors.sunset_main};
    background: ${colors.sunset_8};
`;
export const PatientsSubtitle = styled(Subtitle) `
    font-size: ${fontSizes.MEDIUM};
`;
export const PatientsRecentContainer = styled(FlexColumn) `
    padding: 24px 0;
    align-items: stretch;
    gap: 16px;
`;
export const PatientsRowChevron = styled(ChevronRightIcon) `
    color: ${colors.black_light};
    font-size: 24px !important;
`;
